var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCheckBlueCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#2F7AFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3977 6.60225C14.6174 6.82192 14.6174 7.17808 14.3977 7.39775L8.89775 12.8977C8.67808 13.1174 8.32192 13.1174 8.10225 12.8977L5.60225 10.3977C5.38258 10.1781 5.38258 9.82192 5.60225 9.60225C5.82192 9.38258 6.17808 9.38258 6.39775 9.60225L8.5 11.7045L13.6023 6.60225C13.8219 6.38258 14.1781 6.38258 14.3977 6.60225Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckBlueCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-blue-circle.2532ee7b.svg";
export { ForwardRef as ReactComponent };